import { render, staticRenderFns } from "./KnPagination.vue?vue&type=template&id=71c7f1ab"
import script from "./KnPagination.vue?vue&type=script&lang=js"
export * from "./KnPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports